import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_900')};
  background-image: ${() =>
    `url('${getPublicPath('/images/stateOfHiring/methodology-bg.svg')}')`};
  background-size: 120%;
  background-position: top left -20px;
  padding: ${spacing('xl4')} ${spacing('md')} ${spacing('xl6')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl6')};
    padding-bottom: ${spacing('xl7')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('md')};
  margin: auto;
  text-align: center;
  color: ${color('text_white')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.4;
  }
`;

export const StyledValue = styled.div`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl6')};
  line-height: 1;
  font-weight: ${fontWeight('semiBold')};
  text-transform: uppercase;

  @media (min-width: ${screen('md')}) {
    min-width: 1.6em;
    text-align: right;
  }
`;

export const StyledSignup = styled.div`
  font-size: ${fontSize('md')};
  gap: 0;
`;

export const StyledFunnel = styled.div`
  max-width: ${container('md')};
  margin: auto;
  color: ${color('text_white')};
  line-height: 1.5;
  padding: ${spacing('sm')} ${spacing('md')};
  text-align: left;

  > div {
    max-width: 25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing('sm')};
    margin: auto;
    text-align: center;

    @media (min-width: ${screen('md')}) {
      flex-direction: row;
      text-align: left;
    }
  }

  &:first-of-type {
    background-color: ${color('seq_blue_08')};
    margin-top: ${spacing('xl3')};
  }
  &:nth-of-type(2) {
    background-color: ${color('seq_blue_07')};
    margin-left: ${spacing('md')};
    margin-right: ${spacing('md')};

    @media (min-width: ${screen('md')}) {
      margin-left: ${spacing('xl')};
      margin-right: ${spacing('xl')};
    }
  }
  &:nth-of-type(3) {
    background-color: ${color('seq_blue_06')};
    margin-left: ${spacing('xl')};
    margin-right: ${spacing('xl')};

    @media (min-width: ${screen('md')}) {
      margin-left: ${spacing('xl5')};
      margin-right: ${spacing('xl5')};
    }
  }
  &:nth-of-type(4) {
    margin-left: ${spacing('xl3')};
    margin-right: ${spacing('xl3')};
    background-color: ${color('seq_blue_05')};
    max-width: fit-content;

    @media (min-width: ${screen('md')}) {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const StyledBanner = styled.div`
  max-width: 31rem;
  margin: ${spacing('xl7')} auto 0;
  line-height: 1.5;

  > div {
    display: flex;
    flex-wrap: wrap;
    gap: ${spacing('lg')};
    justify-content: center;
    margin-top: ${spacing('xl2')};
  }

  > ${StyledSignup} {
    gap: ${spacing('xs2')};
    margin-top: ${spacing('md')};
  }
`;
